/* eslint-disable */
import mapStyles from './map-style';

const markers = [];
const places = [];
const bounds = new google.maps.LatLngBounds();
const infowindow = new google.maps.InfoWindow();

function createMarker(contentString, map, markerInfo) {
  const marker = new google.maps.Marker(markerInfo);

  function openMarker() {
    infowindow.setContent(contentString);
    infowindow.open(map, marker);
  }

  if (contentString != null) {
    markers.push(marker); // Put all markers in an array for filter later
    google.maps.event.addListener(marker, 'click', openMarker);

    google.maps.event.addListener(infowindow, 'domready', () => {
      const iwOuter = $('.gm-style-iw');
      const iwBackground = iwOuter.prev();
      iwBackground.children(':nth-child(2)').css({ display: 'none' }); // Remove the background shadow DIV
      iwBackground.children(':nth-child(4)').css({ display: 'none' }); // Remove the white background
      iwBackground.children(':nth-child(3)').attr('style', (i, s) => `${s}z-index: 10 !important;`);
    });
  }
}

function addMarker(place, map) {
  // Set marker contet
  const contentString = `
    <div class="marker-item">
      <div class="marker-item__body">
        <h6>${place.title}</h6>
        ${place.location.address.replace(", ", "<br>")}
      </div>
    </div>`;

  const locations = [];
  if (place.area.id != null) {
    const arr = place.area.id.length;
    for (let i = 0; i < arr; i=i+1) {
      locations.push(place.area.id[i]);
      const locationList = places.find(location => location.id === place.area.id[i]);
      if (!locationList) {
        places.push({
          name: place.area.name[i],
          id: place.area.id[i],
        });
      }
    }
  }

  // Set markerInfo
  const markerInfo = {
    position: new google.maps.LatLng(place.location.lat, place.location.lng),
    map,
    title: place.title,
    icon: {
      url: '/wp-content/themes/bewi/resources/assets/images/Bewi_pin_bla.png',
      // scaledSize: new google.maps.Size(24, 24),
    },
    disableAutoPan: true,
    location: locations,
  };
  // Extend the area view for all markers
  bounds.extend(markerInfo.position);
  // Create marker and eventlisteners
  createMarker(contentString, map, markerInfo);
}

// Function for center map,
function centerMap(map) {
    // Set center of map
  map.setCenter(bounds.getCenter());
  map.setZoom(4);
}

function addPlaces(map) {
  const filerEl = document.getElementById('areaSelect');
  const endpoint = '/wp-json/api/fetch/locations';
  const loadMap = document.querySelector('.loading-map');
  if(loadMap){
    loadMap.classList.remove('d-none');
  }

  fetch(endpoint, {
    mode: 'no-cors',
    headers: {
      'Access-Control-Allow-Origin': '*',
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  }).then(response => response.json())
    .then((responsetext) => {
      responsetext.forEach((place) => {
        addMarker(place, map); // Foreach destination add marker to map
      });
      centerMap(map);
      
      places.forEach((item) => {
        const option = document.createElement('option');
        option.innerHTML = item.name;
        option.setAttribute('value', item.id);
        filerEl.appendChild(option);
      });
      filerEl.addEventListener('change', (el) => {
        filterMarkersByPlace(el.currentTarget.value);
      });
      // places.sort((a, b) => { // Sort locations after name (ABC..)
      //   const nameA = a.name;
      //   const nameB = b.name;
      //   if (nameA < nameB) {
      //     return -1;
      //   }
      //   if (nameA > nameB) {
      //     return 1;
      //   }
      //   // names must be equal
      //   return 0;
      // });
    })
    .then(() => {
      if(loadMap){
        loadMap.classList.add('d-none');
      }
    })
    .catch((error) => {
      console.log(error);
    });
}
function filterMarkersByPlace(value) {
  value = parseInt(value);
  markers.forEach((marker) => {
    marker.setVisible(false);
    if (marker.location.includes(value)) {
      marker.icon.url =  '/wp-content/themes/bewi/resources/assets/images/Bewi_pin_orange_aktiv.png';
    } else {
      marker.icon.url =  '/wp-content/themes/bewi/resources/assets/images/Bewi_pin_bla.png';
    }
    marker.setVisible(true);
  });
}
export default function bewiMap(mapEl) {
  const mapProps = {
    zoom: 15,
    center: new google.maps.LatLng(0, 0),
    mapTypeId: google.maps.MapTypeId.ROADMAP,
    zoomControl: true,
    mapTypeControl: false,
    scaleControl: false,
    disableDefaultUI: true,
    streetViewControl: false,
    rotateControl: false,
    fullscreenControl: false,
    styles: mapStyles,
  };

  const map = new google.maps.Map(mapEl, mapProps);

  addPlaces(map); // Fetch markers

  google.maps.event.addListener(map, 'click', () => {
    infowindow.close();
  });
}


// WEBPACK FOOTER //
// ./scripts/components/maps.js